import { Row, Col } from "react-bootstrap";
import { formatNopol,formatMoney } from "utils/utils";
import { Link, useParams } from "react-router-dom";
import { getPDF } from "../api/ApiPenghapusan";

export default function DetailForm(data) {
  const dataKBM = data?.detailKBM;
  const dataParams = useParams();
  
  const statusBlockirCss = (value) => {
    if (value === '-') {
      return 'badge-green';
    }

    if (value === '1') {
      return 'badge-yellow';
    }

    if (value === '2') {
      return 'badge-red';
    }

    return '';
  };

  const statusPajakCss = (value) => {
    if (value === '1') {
      return 'badge-green';
    }

    if (value === '2') {
      return 'badge-yellow';
    }

    return '';
  };

  const statusStnkCss = (value) => {
    if (value === '1') {
      return 'badge-green';
    }

    if (value === '2') {
      return 'badge-yellow';
    }

    if (value === '3') {
      return 'badge-red';
    }

    return '';
  };

  function downloadPDF(params) {
    getPDF(params).then((response) => {
      if(response?.data?.code === "0000") {
        const linkSource = `data:application/pdf;base64,${response.data.data}`;
        const downloadLink = document.createElement("a");
        const fileName = "detail-kendaraan.pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        alert(response.data.message);
      }
    })
}

  return (
    <>
      <div className="card-header detail-header-mobile p-3">
        <h3 className="card-title mb-2">Detail Kendaraan Bermotor</h3>
        <p className="m-0">Data diakses pada : {dataKBM?.data_diakses_pada}</p>
      </div>
      <div className="custom-card p-3">
        <div className="card-header detail-header-desktop">
          <h3 className="card-title mb-2">Detail Kendaraan Bermotor</h3>
          <p className="m-0">
            Data diakses pada : {dataKBM?.data_diakses_pada}
          </p>
        </div>
        <div className="card-body">
          <Row>
            <Col>
              <h5 className="base-heading-green">Informasi Umum</h5>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={6}>
              <label className="base-label">No. Polisi</label>
              <p className="base-label-desc">
                {formatNopol(dataKBM?.nomor_polisi)}
              </p>
            </Col>
            <Col xs={6} md={6}>
              <label className="base-label">Merk</label>
              <p className="base-label-desc">{dataKBM?.merk}</p>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={6}>
              <label className="base-label">Model</label>
              <p className="base-label-desc">{dataKBM?.model}</p>
            </Col>
            <Col xs={6} md={6}>
              <label className="base-label">Tahun</label>
              <p className="base-label-desc">{dataKBM?.tahun}</p>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={6}>
              <label className="base-label">Warna Kendaraan</label>
              <p className="base-label-desc">{dataKBM?.warna}</p>
            </Col>
            <Col xs={6} md={6}>
              <label className="base-label">Tgl. Kepemilikan</label>
              <p className="base-label-desc">{dataKBM?.tanggal_kepemilikkan}</p>
            </Col>
          </Row>

          {/* Informasi Pajak Start */}
          <Row>
            <Col>
              <h5 className="base-heading-green">Informasi Pajak</h5>
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={6}>
              <label className="base-label">Tgl. Akhir Pajak</label>
              <p className="base-label-desc">{dataKBM?.tanggal_akhir_pajak}</p>
            </Col>
            <Col xs={6} md={6}>
              <label className="base-label">Tgl. Akhir STNK</label>
              <p className="base-label-desc">{dataKBM?.tanggal_akhir_stnk}</p>
            </Col>
            <Col xs={6} md={6}>
              <label className="base-label">Status Pajak</label>
              <p className={statusPajakCss(dataKBM?.flag_pajak)}>
                {dataKBM?.status_pajak}
              </p>
            </Col>
            {dataKBM?.flag_pajak === '2' && (
              <Col xs={6} md={6}>
                <label className="base-label">Besaran Pajak</label>
                <p className="base-label-desc">
                  Rp. {formatMoney(dataKBM?.jumlah)}
                </p>
              </Col>
            )}
          </Row>
          {/* Informasi Pajak End */}

          {/* Informasi Status Start */}
          <Row>
            <Col>
              <h5 className="base-heading-green">Informasi Status</h5>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={6}>
              <label className="base-label">Status STNK</label>
              <p className={statusStnkCss(dataKBM?.flag_stnk)}>
                {dataKBM?.status_stnk}
              </p>
            </Col>
            <Col xs={6} md={6}>
              <label className="base-label">Status Blokir</label>
              <p className={statusBlockirCss(dataKBM?.flag_blockir)}>
                {dataKBM?.status_blockir}
              </p>
            </Col>
          </Row>
          {/* Informasi Status End */}
        </div>
      </div>

      <Row className="ps-4 pe-4">
        <Col>
          <Link to="/">
            <button className="base-btn-secondary c-btn">
              <span className="px-2">Cek Kendaraan Lain</span>
            </button>
          </Link>
        </Col>
        <Col>
          <button className="btn btn-success c-btn" type="button" onClick={() => downloadPDF(dataParams)} >
            <span className="px-2">Unduh</span>
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 11.5V14.8333C16 15.2754 15.8244 15.6993 15.5118 16.0118C15.1993 16.3244 14.7754 16.5 14.3333 16.5H2.66667C2.22464 16.5 1.80072 16.3244 1.48816 16.0118C1.17559 15.6993 1 15.2754 1 14.8333V11.5M4.33333 7.33333L8.5 11.5L12.6667 7.33333M8.5 11.5V1.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </Col>
      </Row>
    </>
  );
}
